import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  text-align: center;
  font-size: 2rem;
`;
